import React from "react"
import WhyUS from "assets/images/whyus2.avif"
import { TbLifebuoyFilled } from "react-icons/tb"
import { SiScaleway } from "react-icons/si"
import { MdSecurity, MdOutlinePriceCheck , MdOutlineSupportAgent } from "react-icons/md"
import { SiAltiumdesigner } from "react-icons/si";
import { FaGlobe } from "react-icons/fa";
const Whyus = () => {
  return (
    <div className="p-4 h-100" style={{ backgroundColor: "rgba(240,240,240)" }}>
      <h2
        id="why-us"
        className=" color-purple fw-bold mt-2 lh-base mb-4 mb-xl-5 text-center"
      >
        Why Businesses Trust Zithas Technologies
      </h2>
      <div className="row">
        {/* India Content */}
        {/* <div className="col-xl-7 ps-xl-5">
          <div className="Why-Card">
            <div className="d-flex ">
              <div className="p-2 pt-1">
                <TbLifebuoyFilled fontSize={24} className="me-2 color-purple" />
              </div>
              <div>
                <h4 className="fw-bold color-purple mb-0">Full Lifecycle Support</h4>
                <h5 className="mt-2 lh-base">
                  From product planning and development to post-deployment support, our Indian tech team delivers end-to-end expertise.
                </h5>
              </div>
            </div>
          </div>
          <div className="Why-Card mt-4">
            <div className="d-flex">
              <div className="p-2 pt-1">
                <SiScaleway fontSize={24} className="me-2 color-purple" />
              </div>
              <div>
                <h4 className="fw-bold mb-0 color-purple">Scalable & Adaptable</h4>

                <h5 className="mt-2 lh-base">
                  We support growing businesses across all cities, ensuring seamless scalability and performance.
                </h5>
              </div>
            </div>
          </div>
          <div className="Why-Card mt-4">
            <div className="d-flex">
              <div className="p-2 pt-1">
                <MdSecurity fontSize={24} className="me-2 color-purple" />
              </div>
              <div>
                <h4 className="fw-bold mb-0 color-purple">Security & Compliance at Core</h4>
                <h5 className="mt-2 lh-base">
                  We ensure compliance with Indian IT regulations and protect your data with enterprise-grade encryption.
                </h5>
              </div>
            </div>
          </div>
          <div className="Why-Card mt-4">
            <div className="d-flex">
              <div className="p-2 pt-1">
                <FaGlobe fontSize={24} className="me-2 color-purple" />
              </div>
              <div>
                <h4 className="fw-bold mb-0 color-purple">Domain Expertise in Indian Sectors</h4>
                <h5 className="mt-2 lh-base">
                  Pre-built modules for sectors like EdTech, AgriTech, BFSI, and Retail help accelerate your go-to-market.
                </h5>
              </div>
            </div>
          </div>
          <div className="Why-Card mt-4">
            <div className="d-flex">
              <div className="p-2 pt-1">
                <MdOutlinePriceCheck  fontSize={24} className="me-2 color-purple" />
              </div>
              <div>
                <h4 className="fw-bold mb-0 color-purple">Affordable, Transparent Pricing</h4>
                <h5 className="mt-2 lh-base">
                  Enterprise-grade software at competitive pricing with zero hidden costs.
                </h5>
              </div>
            </div>
          </div>
        </div> */}

        {/* Uk Content */}
        <div className="col-xl-7 ps-xl-5">
          <div className="Why-Card">
            <div className="d-flex ">
              <div className="p-2 pt-1">
                <TbLifebuoyFilled fontSize={24} className="me-2 color-purple" />
              </div>
              <div>
                <h4 className="fw-bold color-purple mb-0">Full Lifecycle Support</h4>
                <h5 className="mt-2 lh-base">
                  Close collaboration throughout planning, MVP, pilot testing, and full deployment stages to reduce risk.
                </h5>
              </div>
            </div>
          </div>
          <div className="Why-Card mt-4">
            <div className="d-flex">
              <div className="p-2 pt-1">
                <SiScaleway fontSize={24} className="me-2 color-purple" />
              </div>
              <div>
                <h4 className="fw-bold mb-0 color-purple">Scalable & Adaptable</h4>
                <h5 className="mt-2 lh-base">
                  Designed to comply with UK and EU regulations—ideal for businesses operating across multiple geographies.
                </h5>
              </div>
            </div>
          </div>
          <div className="Why-Card mt-4">
            <div className="d-flex">
              <div className="p-2 pt-1">
                <MdSecurity fontSize={24} className="me-2 color-purple" />
              </div>
              <div>
                <h4 className="fw-bold mb-0 color-purple">Security & Compliance at Core</h4>
                <h5 className="mt-2 lh-base">
                  Hosting solutions built to meet GDPR requirements, including consent tracking and data protection readiness.
                </h5>
              </div>
            </div>
          </div>
          <div className="Why-Card mt-4">
            <div className="d-flex">
              <div className="p-2 pt-1">
                <SiAltiumdesigner fontSize={24} className="me-2 color-purple" />
              </div>
              <div>
                <h4 className="fw-bold mb-0 color-purple">Exceptional UI/UX Focus</h4>
                <h5 className="mt-2 lh-base">
                  Our user-first design approach ensures UK clients receive clean, accessible, and elegant interfaces.
                </h5>
              </div>
            </div>
          </div>
          <div className="Why-Card mt-4">
            <div className="d-flex">
              <div className="p-2 pt-1">
                <MdOutlineSupportAgent  fontSize={24} className="me-2 color-purple" />
              </div>
              <div>
                <h4 className="fw-bold mb-0 color-purple">Continuous Improvement & Support</h4>
                <h5 className="mt-2 lh-base">
                  Post-launch support includes analytics, upgrades, and iterative optimization for long-term success.
                </h5>
              </div>
            </div>
          </div>
        </div>

        {/* Usa content */}
        {/* <div className="col-xl-7 ps-xl-5">
          <div className="Why-Card">
            <div className="d-flex ">
              <div className="p-2 pt-1">
                <TbLifebuoyFilled fontSize={24} className="me-2 color-purple" />
              </div>
              <div>
                <h4 className="fw-bold color-purple mb-0">Full Lifecycle Support</h4>
                <h5 className="mt-2 lh-base">
                 From strategy and UI/UX to deployment and DevOps, we provide a one-stop technology solution backed by strong SLAs.
                </h5>
              </div>
            </div>
          </div>
          <div className="Why-Card mt-4">
            <div className="d-flex">
              <div className="p-2 pt-1">
                <SiScaleway fontSize={24} className="me-2 color-purple" />
              </div>
              <div>
                <h4 className="fw-bold mb-0 color-purple">Scalable & Adaptable</h4>
                <h5 className="mt-2 lh-base">
                  Cloud-native systems built for AWS, Azure, and GCP, designed to handle growth with ease.
                </h5>
              </div>
            </div>
          </div>
          <div className="Why-Card mt-4">
            <div className="d-flex">
              <div className="p-2 pt-1">
                <MdSecurity fontSize={24} className="me-2 color-purple" />
              </div>
              <div>
                <h4 className="fw-bold mb-0 color-purple">Collaborative Work Culture</h4>
                <h5 className="mt-2 lh-base">
                  We integrate seamlessly with your internal team using platforms like Slack, Zoom, and JIRA.
                </h5>
              </div>
            </div>
          </div>
          <div className="Why-Card mt-4">
            <div className="d-flex">
              <div className="p-2 pt-1">
                <MdOutlineSupportAgent fontSize={24} className="me-2 color-purple" />
              </div>
              <div>
                <h4 className="fw-bold mb-0 color-purple">Results-Focused Delivery</h4>
                <h5 className="mt-2 lh-base">
                  We prioritize outcomes—delivering solutions that reduce turnaround times and maximize ROI.
                </h5>
              </div>
            </div>
          </div>
        </div>  */}
        <div className="col-xl-5 ps-xl-5 mt-4 mt-xl-0">
          <div className="img-bg-2 ">
            <img src={WhyUS} className=" object-fit-cover" />
          </div>
        </div>
      </div>
    </div>
  )
}
export default Whyus
